<template>
    <jet-danger-button class="ml-2 text-xs px-3 py-0.5" @click="confirmDeletion">
        Delete
    </jet-danger-button>

    <jet-dialog-modal :show="confirming" @close="closeModal">
        <template #title>
            Delete Segment
        </template>

        <template #content>
            <slot name="content"></slot>
        </template>

        <template #footer>
            <jet-secondary-button @click="closeModal">
                Cancel
            </jet-secondary-button>

            <jet-danger-button class="ml-2" @click="confirmed" :class="{ 'opacity-25': processing }" :disabled="processing">
                <slot name="delete-button">Confirm</slot>
            </jet-danger-button>
        </template>
    </jet-dialog-modal>
</template>

<script>
import {defineComponent, ref} from 'vue';
import JetDialogModal from '@/Jetstream/DialogModal.vue';
import JetDangerButton from '@/Jetstream/DangerButton.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetInputError from '@/Jetstream/InputError.vue';
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue';
import axios from 'axios';

export default defineComponent({
    name: 'DeleteButton',
    components: {
        JetDangerButton,
        JetDialogModal,
        JetInput,
        JetInputError,
        JetSecondaryButton,
    },
    props: {
        action: {
            type: String,
            required: true,
        },
    },
    emits: ['deleted'],
    setup(props, { emit }) {
        const confirming = ref(false);
        const processing = ref(false);

        const closeModal = () => {
            confirming.value = false;
        };

        return {
            confirming,
            processing,
            closeModal,
            confirmDeletion() {
                confirming.value = true;
            },
            confirmed() {
                processing.value = true;

                axios.delete(props.action).then((response) => {
                    confirming.value = false;
                    processing.value = false;

                    emit('deleted', response);
                });
            },
        };
    },
});
</script>

<style scoped>

</style>
